import axios from 'axios'
import useSWR from 'swr'
import { useLocale } from 'hooks'

export const useReturn = (hashId: string): UseReturnResponse => {
  const { localiseUrl } = useLocale()

  const { data, error } = useSWR(
    hashId ? `/api/returns/${hashId}` : null,
    (url) =>
      axios(localiseUrl(url, { localeAsParam: true })).then((res) => res.data)
  )

  return {
    data,
    error,
    loading: !data && !error
  }
}

interface UseReturnResponse {
  data: any
  error: any
  loading: boolean
}
